import State from 'interfaces/state/State';

export const type$ = (state: State): 'creator' | 'manager' | 'admin' | null => state.users.type;
export const users$ = (state: State) => state.users.users;
export const currentUser$ = (state: State) => state.users.currentUser;
export const isLoading$ = (state: State) => state.users.isLoading;
